import { CHARACTER_TYPES } from "features/languages/utils/constants";

export const getCharacterTypesList = () => {
  const list: { value: number; label: string }[] = [];

  Object.entries(CHARACTER_TYPES).forEach(([key, label]) => {
    const roleIndex = Number(key);

    list.push({
      value: roleIndex,
      label,
    });
  });

  return list;
};

export const isLanguageDeletable = (languageCode: string) =>
  !window.appConfig.languages.nonDeletable.includes(languageCode);

export const isLanguageHidden = (languageCode: string) =>
  window.appConfig.languages.hiddenLanguages.includes(languageCode);
